import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class StudioErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="studio-error-boundary">
          <h3>Etwas ist schiefgelaufen</h3>
          <p>{this.state.error?.message || 'Unbekannter Fehler'}</p>
          <button
            className="studio-btn studio-btn-primary"
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            Erneut versuchen
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default StudioErrorBoundary;
